<template>
    <section class="section container">
        <div class="row">
            <div class="col-12">
                <div class="recipes-category-container js-appear-animation-row">
                    <div class="recipes-category cta-hover" :class="{'recipes-category-active': activeCategory == 'all'}" data-category="all" @click="resetFilters()">
                        <div class="hover-text">
                            <div style=" display: flex;">
                                <img :src="handleTagIcon('all')" />
                                <span>All</span>
                            </div>
                        </div>
                        <div class="hover-text bottom cta-hover">
                            <div style=" display: flex;">
                                <img :src="handleTagIcon('all')" />
                                <span>All</span>
                            </div>
                        </div>
                    </div>
                    <button v-for="(item, index) in filters" class="recipes-category cta-hover" :class="{'recipes-category-active': activeCategory == item.CodeName}" :data-category="item.CodeName" @click="handleFilter(item.CodeName)">
                        <div class="hover-text">
                            <div style=" display: flex;">
                                <img :src="handleTagIcon(item.DisplayName)" />
                                {{item.DisplayName}}
                            </div>
                        </div>
                        <div class="hover-text bottom">
                            <div style=" display: flex;">
                                <img :src="handleTagIcon(item.DisplayName)" />
                                {{item.DisplayName}}
                            </div>
                        </div>
                    </button>                    
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12" v-if="listing.length">
                <div class="carousel carousel--recipes cards--related cards--grid cards d-flex">
                    <button class="carousel-btn carousel-btn-left"></button>
                    <button class="carousel-btn carousel-btn-right"></button>
                    <summary-item v-for="(item, index) in listing" v-bind:item="item" v-bind:key="item.DetailID"></summary-item>
                </div>
            </div>

            <div class="cards-no-results col-lg-12" v-if="listing.length < 1">
                <h2>No Results</h2>
                <p>Sorry, there are no results matching your Sort and Filter criteria.</p>
                <a href="javascript:void(0);" v-on:click="resetFilters">Clear Sort and Filters</a>
            </div>
        </div>
    </section>
</template>

<script>
    import SmoothScroll from 'smooth-scroll';
	import {mapState, mapActions, mapMutations} from 'vuex';
    import SummaryItem from '../components/listing/recipe-list-summary-item';
    //import recipefilter from '../filters/recipe-filter';

	export default {
        props: ['filterid', 'filtertype', 'result', 'resource', 'title', 'filters'],
		data: function () {
			return {
                activeCategory: 'all'
            }
        },
		computed: mapState({
            loading: state => state.listing.loading,
            listing: state => state.listing.listing,
            loadedImages: state => state.listing.loadedImages,
    }),
		components: {
            'summary-item': SummaryItem,
    },
		mounted: function () {
            let _this = this;
        // take props and send to vuex store
        this.setInitData(this.result);
        this.setResource(this.resource);

        // after filter comes back, scroll to the top
        let scroll = new SmoothScroll();
	    let options = {
            header: '[data-scroll-header]',
            speed: 1000,
            offset: 96
        };
        //
        this.$store.subscribe((mutation, state) => {
            if (mutation.type === 'listing/setLoadedImageState') {
                if (this.loadedImages === 8)
                {
                    this.handleLeftToRightAnimation();
                }
            }
        });
        // after any api calls, scroll to the top of the list
        this.$store.subscribeAction((action, state) => {
	        if (action.type === 'listing/setFilter') {
                let anchor = document.querySelector('#' + _this.filterid);
                let header = document.getElementsByClassName('header')[0];
            }
        });

        // if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
	        this.$store.subscribe((mutation, state) => {
		        if (mutation.type === 'listing/updateSpecification') {
                this.setFilter();
            }
        });        
    },
	methods: {
        ...mapActions('listing', { setFilter: 'setFilter' }),
		...mapMutations('listing', {setInitData: 'setInitData' }),
		...mapMutations('listing', {setResource: 'setResource' }),
		...mapMutations('listing', { resetSpecification: 'resetSpecification' }),
		...mapMutations('listing', { updateSpecification: 'updateSpecification' }),	
        ...mapMutations('listing', { setLoadedImageInitialState: 'setLoadedImageInitialState' }),
        
        handleLeftToRightAnimation(){
            const anchorElements = document.querySelectorAll('.card-content-wrapper');

             anchorElements.forEach((item) => {
                item.classList.add('opacity-0');
            });

            // Add the 'fade-in-LtF' class to each element with a delay
            anchorElements.forEach((item, index) => {
                setTimeout(() => {
                    item.classList.add('fade-in-LtF');
                }, index * 200); // Delay by 0.2 seconds per item
            });
        },
        handleTagIcon(icon){
            return `./Content/images/Custom/tagCategories/${icon}.svg` 
        },
        resetFilters() {
		    this.resetSpecification();
            this.activeCategory = 'all';
        },
        handleFilter(filter) {		   
            this.activeCategory = filter;
            this.updateSpecification({ key: 'RecipeType', value: filter });
            this.setLoadedImageInitialState();
        }
    }
}
</script>